// extracted by mini-css-extract-plugin
module.exports = {"gettingStartedWholeBox":"Applications_gettingStartedWholeBox__fAvNw","slide-in-bottom":"Applications_slide-in-bottom__2mKYg","hideBox":"Applications_hideBox__AxEhP"};